import { SESSION_COOKIE_STATUS_URL } from '../constants';

/**
 * Cheap check that the session cookie carries a present, unexpired JWT. Returns the
 * HTTP status (200 = valid), or 0 if the request could not be made.
 */
export async function fetchSessionCookieStatus(): Promise<number> {
  try {
    const response = await fetch(SESSION_COOKIE_STATUS_URL, {
      credentials: 'include',
    });
    return response.status;
  } catch {
    return 0;
  }
}
